import { SET_PAGE_STATE, RESET_PAGE_STATE } from './actionTypes';

const initialState = {
  Questions: null,
  Requests: null,
};

const crossPageInteractionsReducer = (
  state = initialState,
  { type, payload }
) => {
  switch (type) {
    case SET_PAGE_STATE:
      return {
        ...state,
        ...payload,
      };
    case RESET_PAGE_STATE:
      return {
        ...state,
        [payload]: null,
      };
    default:
      return state;
  }
};

export default crossPageInteractionsReducer;
